<div class="container">
    <div class="card-container sigle-page-card" *ngIf="!isLoadingResults">
        <div class="card-header-wrapper">
            <h3 class="card-title"> {{ customMsgService.translate('recuperarPassword') }}</h3>
            <span> </span>
        </div>
        <div class="card-component">
            <form *ngIf="!isLoadingResults" class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;"
                [formGroup]="formGroup">

                <fieldset class="k-form-fieldset">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" text="Email"> </kendo-label>
                        <kendo-textbox id="formTextBox" formControlName="email" required>
                        </kendo-textbox>
                    </kendo-formfield>
                    <br />
                    <hr />
                    <br />
                    <button kendoButton (click)="guardar()" themeColor="primary">
                        {{ customMsgService.translate('btnEnviar') }}
                    </button>
                </fieldset>
            </form>
        </div>
        <div class="" *ngIf="isLoadingError" ng-hide="hideError">
            <p style="color: #e22f2f;">Ocorreu um erro. Por favor, tente mais tarde.</p>
        </div>
    </div>
    <div id="errorMessage" class="card-container sigle-page-card" *ngIf="isLoadingResults">
        <p style="color: #4dbd74;">Foi enviado um email com instruções para recuperar a sua password</p>
        <button kendoButton (click)="loginPage()" themeColor="primary">Ir para a página de login</button>
    </div>
</div>